import { Label } from '@/components/ui/label';
import React from 'react';

interface CustomFieldLabelProps
  extends React.ComponentPropsWithoutRef<typeof Label> {
  required?: boolean;
}

export const CustomFieldLabel = React.forwardRef<
  React.ElementRef<typeof Label>,
  CustomFieldLabelProps
>(({ required, children, ...props }, ref) => {
  return (
    <Label ref={ref} {...props}>
      {children} {required && <span className='text-destructive'> *</span>}
    </Label>
  );
});

CustomFieldLabel.displayName = 'CustomFieldLabel';
